/* Bejesa: conditional engraving validation v2.
   Personalized products (tag "personalizowany" OR variant SKU contains "PERS"):
     intercept ATC click in capture phase, block submit if visible engraving
     field empty, show error UI.
   Non-personalized: strip [required] from any property inputs (defensive
   against GemPages rendering required field in hidden section). */
(function () {
  var p = window.__BJ_PRODUCT;
  if (!p) return;

  var sel = 'form[action*="/cart/add"] input[name^="properties["], form[action*="/cart/add"] textarea[name^="properties["]';

  var hasTag = p.tags && p.tags.indexOf("personalizowany") !== -1;
  var hasPersSKU = false;
  if (p.skus && p.skus.length) {
    for (var s = 0; s < p.skus.length; s++) {
      if ((p.skus[s] || "").indexOf("PERS") !== -1) { hasPersSKU = true; break; }
    }
  }
  var isPersonalized = hasTag || hasPersSKU;

  if (!isPersonalized) {
    var nodes = document.querySelectorAll(sel);
    for (var i = 0; i < nodes.length; i++) nodes[i].removeAttribute("required");
    return;
  }

  function findEmptyVisibleProperty(form) {
    var fields = form.querySelectorAll('input[name^="properties["], textarea[name^="properties["]');
    for (var i = 0; i < fields.length; i++) {
      var f = fields[i];
      var rect = f.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) continue;
      if (!String(f.value || "").trim()) return f;
    }
    return null;
  }

  function showError(field) {
    field.scrollIntoView({behavior: "smooth", block: "center"});
    setTimeout(function () { try { field.focus(); } catch(e) {} }, 350);
    field.style.outline = "2px solid #c0392b";
    field.style.outlineOffset = "2px";
    var holder = field.parentElement || document.body;
    var msg = holder.querySelector(".bj-required-msg");
    if (!msg) {
      msg = document.createElement("div");
      msg.className = "bj-required-msg";
      msg.style.cssText = "color:#c0392b;font-size:14px;margin-top:6px;font-weight:500;font-family:inherit;";
      msg.textContent = "Prosimy o podanie tekstu do graweru";
      holder.appendChild(msg);
    }
    field.addEventListener("input", function clear() {
      if (String(field.value || "").trim()) {
        field.style.outline = "";
        if (msg && msg.parentNode) msg.parentNode.removeChild(msg);
        field.removeEventListener("input", clear);
      }
    });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("button.gp-button-atc, button[name='add']");
    if (!btn) return;
    var form = btn.closest("form");
    if (!form) return;
    var empty = findEmptyVisibleProperty(form);
    if (empty) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError(empty);
    }
  }, true);
})();
